import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ABTestSlice } from '../store/ABTest/ABTest.slice';
export function useGAEventMeta() {
    var features = useSelector(ABTestSlice.selectors.getAllFeatures);
    return useMemo(function () {
        return {
            ABTests: { features: features },
        };
    }, [features]);
}
